import { ReportsTableData } from "../../../../../../../store/reports/utils/types/types";

export const titleBySourceType = new Map<
  ReportsTableData["source_type"],
  string
>([
  ["view", "Billing Report"],
  ["dashboard", "Dashboard"],
]);
